'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var NotInitializedError = /*#__PURE__*/function (_Error) {
  _inherits(NotInitializedError, _Error);

  var _super = _createSuper(NotInitializedError);

  function NotInitializedError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not initialized';

    _classCallCheck(this, NotInitializedError);

    _this = _super.call(this, message);
    _this.name = 'NotInitializedError';
    _this.code = NotInitializedError.code;
    return _this;
  }

  return NotInitializedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NotInitializedError.code = 'ERR_NOT_INITIALIZED';
exports.NotInitializedError = NotInitializedError;

var AlreadyInitializingError = /*#__PURE__*/function (_Error2) {
  _inherits(AlreadyInitializingError, _Error2);

  var _super2 = _createSuper(AlreadyInitializingError);

  function AlreadyInitializingError() {
    var _this2;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cannot initialize an initializing node';

    _classCallCheck(this, AlreadyInitializingError);

    _this2 = _super2.call(this, message);
    _this2.name = 'AlreadyInitializingError';
    _this2.code = AlreadyInitializedError.code;
    return _this2;
  }

  return AlreadyInitializingError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

AlreadyInitializingError.code = 'ERR_ALREADY_INITIALIZING';
exports.AlreadyInitializingError = AlreadyInitializingError;

var AlreadyInitializedError = /*#__PURE__*/function (_Error3) {
  _inherits(AlreadyInitializedError, _Error3);

  var _super3 = _createSuper(AlreadyInitializedError);

  function AlreadyInitializedError() {
    var _this3;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cannot re-initialize an initialized node';

    _classCallCheck(this, AlreadyInitializedError);

    _this3 = _super3.call(this, message);
    _this3.name = 'AlreadyInitializedError';
    _this3.code = AlreadyInitializedError.code;
    return _this3;
  }

  return AlreadyInitializedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

AlreadyInitializedError.code = 'ERR_ALREADY_INITIALIZED';
exports.AlreadyInitializedError = AlreadyInitializedError;

var NotStartedError = /*#__PURE__*/function (_Error4) {
  _inherits(NotStartedError, _Error4);

  var _super4 = _createSuper(NotStartedError);

  function NotStartedError() {
    var _this4;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not started';

    _classCallCheck(this, NotStartedError);

    _this4 = _super4.call(this, message);
    _this4.name = 'NotStartedError';
    _this4.code = NotStartedError.code;
    return _this4;
  }

  return NotStartedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NotStartedError.code = 'ERR_NOT_STARTED';
exports.NotStartedError = NotStartedError;

var NotEnabledError = /*#__PURE__*/function (_Error5) {
  _inherits(NotEnabledError, _Error5);

  var _super5 = _createSuper(NotEnabledError);

  function NotEnabledError() {
    var _this5;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not enabled';

    _classCallCheck(this, NotEnabledError);

    _this5 = _super5.call(this, message);
    _this5.name = 'NotEnabledError';
    _this5.code = NotEnabledError.code;
    return _this5;
  }

  return NotEnabledError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

NotEnabledError.code = 'ERR_NOT_ENABLED';
exports.NotEnabledError = NotEnabledError;

var TimeoutError = /*#__PURE__*/function (_Error6) {
  _inherits(TimeoutError, _Error6);

  var _super6 = _createSuper(TimeoutError);

  function TimeoutError() {
    var _this6;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'request timed out';

    _classCallCheck(this, TimeoutError);

    _this6 = _super6.call(this, message);
    _this6.name = 'TimeoutError';
    _this6.code = TimeoutError.code;
    return _this6;
  }

  return TimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

TimeoutError.code = 'ERR_TIMEOUT';
exports.TimeoutError = TimeoutError;